<template>
  <label class="uradio" :class="{'uradio_disabled':disabled}">
    <input tabindex="-1" type="radio" :name="name" v-model="val" :value="inputvalue" :required="required?'required':false" :readonly="disabled">
    <div class="uradio__dot" :tabindex="disabled?false:0" @keypress.enter.space="$el.click()"></div>
    <span v-if="text">{{text}}</span>
  </label>
</template>

<script>
  export default {
    props: {
      name: {type: String, required: true},
      required: {type: Boolean},
      inputvalue: {type: String, required: true},
      text: {type: String },
      modelValue: {type: String},
      disabled: { type: Boolean, default: false },
    },
    computed: {
      val:{
        get(){
          return this.modelValue
        },
        set(v){
          this.$emit('update:modelValue', v)
        },
      }
    }
  }
</script>

<style lang="sass" scoped>
.uradio
  display: flex
  align-items: flex-start
  cursor: pointer
  color: colors.$gray7
  font-size: 16px 
  line-height: 26px
  &_disabled
    cursor: auto
    pointer-events: none
  input
    position: absolute
    opacity: 0
  input:checked + &__dot
    border-color: colors.$gray7
    &::after
      content: ''
  &__dot
    flex-shrink: 0
    width: 24px
    height: 24px
    border-radius: 50%
    border: 2px solid colors.$silver
    display: flex
    align-items: center
    justify-content: center
    &:not(:last-child)
      margin-right: 16px
    &::after
      display: block
      background: colors.$newred
      width: 12px 
      height: 12px
      border-radius: 50%
      
  
  
</style>